import {
  CLIENT_SET_CURRENT,
  CLIENT_SET_LIST,
  CLIENT_SET_ERROR,
  CLIENT_SET_AGREEMENTS,
  CLIENT_ORGANIZATIONS_LIST,
  CLIENT_ADD_TO_LIST,
  CLIENT_SET_INTEREST,
  CLIENT_ADD_TO_INTEREST,
  CLIENT_SET_DOC_TYPES,
} from './actionTypes';
import { clientApi } from 'helpers/api/client';
import { agreementApi } from 'helpers/api/agreement';
import { successToast } from 'configuration/notifications';

export const Client = {
  getClientList: (queryParams) => async (dispatch) => {
    dispatch(Client.setClientList(null));

    clientApi
      .getClientList(queryParams || {})
      .then(({ data } = {}) => {
        dispatch(Client.setClientList(data));
      })
      .catch(() => dispatch(Client.setClientList([])));
  },

  getDocTypeList: () => async (dispatch) => {
    dispatch(Client.setClientList(null));

    clientApi
      .getDocTypes()
      .then(({ data } = {}) => {
        dispatch(Client.setDocTypeList(data));
      })
      .catch(() => dispatch(Client.setDocTypeList([])));
  },

  getOrganizations: () => async (dispatch) => {
    agreementApi.getOrganizations().then(({ data } = {}) => {
      dispatch(Client.setOrganizationsList(data.results));
    });
  },

  getAgreements: (clientID) => async (dispatch) => {
    agreementApi.getAgreements({ clientID }).then(({ data } = {}) => {
      dispatch(Client.setAgreementsList(data));
    });
  },

  setOrganizationsList: (payload) => ({
    type: CLIENT_ORGANIZATIONS_LIST,
    payload,
  }),

  setAgreementsList: (payload) => ({
    type: CLIENT_SET_AGREEMENTS,
    payload,
  }),

  getClient: (clientId) => async (dispatch) => {
    dispatch(Client.setClientCurrent(null));

    clientApi
      .getClient(clientId)
      .then(({ data } = {}) => {
        dispatch(Client.setClientCurrent(data));
        dispatch(Client.setClientInterest(data?.interests));
      })
      .catch(() => dispatch(Client.setClientError(true)));
  },

  updateClient: (clientId, newData) => async (dispatch) => {
    clientApi.updateClient(clientId, newData).then(({ data } = {}) => {
      dispatch(Client.setClientCurrent(data));
      successToast('Клиент успешно изменен');
    });
  },

  sendClientTo1C: (clientId) => async (dispatch) => {
    clientApi.updateClient(clientId, { isReadyFor1C: true }).then(({ data } = {}) => {
      dispatch(Client.setClientCurrent(data));
      successToast('Клиент успешно отправлен в 1С');
    });
  },

  addCreatedClientToList: (payload) => ({
    type: CLIENT_ADD_TO_LIST,
    payload,
  }),

  addCreatedClientInterestToList: (payload) => ({
    type: CLIENT_ADD_TO_INTEREST,
    payload,
  }),

  setClientCurrent: (payload) => ({
    type: CLIENT_SET_CURRENT,
    payload,
  }),

  setClientInterest: (payload) => ({
    type: CLIENT_SET_INTEREST,
    payload,
  }),

  setClientError: (payload) => ({
    type: CLIENT_SET_ERROR,
    payload,
  }),

  setClientList: (payload) => ({
    type: CLIENT_SET_LIST,
    payload,
  }),

  setDocTypeList: (payload) => ({
    type: CLIENT_SET_DOC_TYPES,
    payload,
  }),
};
